interface LoadingDotsProps {
  label?: string
  size?: 'sm' | 'md'
}

export function LoadingDots({ label, size = 'md' }: LoadingDotsProps) {
  const dotClass = size === 'sm' ? 'w-1.5 h-1.5' : 'w-2 h-2'
  return (
    <div className="flex flex-col items-center gap-3 animate-fade-in">
      <div
        className="flex items-center gap-1.5"
        role="status"
        aria-label={label ?? 'Loading'}
        aria-live="polite"
      >
        {[0, 1, 2].map((i) => (
          <span
            key={i}
            className={`${dotClass} rounded-full bg-brand-primary animate-bounce`}
            style={{ animationDelay: `${i * 150}ms` }}
          />
        ))}
      </div>
      {label && (
        <div className="text-brand-text-muted text-sm font-medium text-center">
          {label}
        </div>
      )}
    </div>
  )
}
